import { c as _c } from "react/compiler-runtime";
import { Checkbox, FormInput, Hint, Modal, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { updateActiveCampaignSettings } from 'modules/profile/integrations/active-campaign-integration/api/active-campaign-settings-api';
import { ActiveCampaignTriggerEnum, ActiveCampaignTriggerTitle } from 'modules/profile/integrations/active-campaign-integration/enums/active-campaign-trigger-enum';
import { useActiveCampaignSettings } from 'modules/profile/integrations/active-campaign-integration/hooks/use-active-campaign-settings';
import { ActiveCampaignSettingsErrorInterface, ActiveCampaignSettingsInterface } from 'modules/profile/integrations/active-campaign-integration/types/active-campaign-settings-interface';
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration';
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton';
import { getHelpPageLinkActiveCampaign } from 'modules/profile/integrations/utils/get-help-page-link-active-campaign';
import React, { useEffect, useState } from 'react';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { ActiveCampaignIntegrationIcon } from '@systemeio/ui/icons';
const defaultValues: ActiveCampaignSettingsInterface = {
  active: false,
  apiUrl: null,
  token: null,
  triggers: []
};
const defaultErrors = {
  apiUrl: '',
  token: '',
  common: []
};
export const ActiveCampaignIntegrationComingSoon = () => {
  const $ = _c(8);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ActiveCampaignIntegrationIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.user_settings.integrations_page.active_campaign.name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.user_settings.integrations_page.active_campaign.subtitle-2");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <WrapperIntegration icon={t0} title={t1} subTitle={t2} isComingSoon={true} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const ActiveCampaignIntegration = () => {
  const $ = _c(21);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [tempState, setTempState] = useState(defaultValues);
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const [isFetching, setIsFetching] = useState(false);
  const {
    activeCampaignData,
    mutate
  } = useActiveCampaignSettings();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function handleOpenModal() {
      setOpened(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleOpenModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleCloseModal() {
      setOpened(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCloseModal = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleAfterLeaveModal() {
      setTempState(defaultValues);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleAfterLeaveModal = t2;
  let t3;
  if ($[3] !== mutate || $[4] !== t || $[5] !== tempState) {
    t3 = async () => {
      ;
      try {
        setErrors(defaultErrors);
        setIsFetching(true);
        const response = await updateActiveCampaignSettings(tempState);
        await mutate(response.data, false);
        setIsFetching(false);
        toast.success(t("global.changes_saved"));
        setErrors(defaultErrors);
      } catch (t4) {
        const e = t4;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          const activeCampaignSettingErrors = e.errors;
          setErrors(prev => ({
            ...prev,
            apiUrl: activeCampaignSettingErrors.fields.apiUrl?.join(""),
            token: activeCampaignSettingErrors.fields.token?.join("")
          }));
          if (e.errors.common) {
            const commonErrors = e.errors.common;
            setErrors(prev_0 => ({
              ...prev_0,
              common: commonErrors
            }));
          }
        } else {
          toast.error(t("global.error"));
        }
      }
    };
    $[3] = mutate;
    $[4] = t;
    $[5] = tempState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onSubmit = t3;
  let t4;
  if ($[7] !== activeCampaignData) {
    t4 = () => {
      if (activeCampaignData) {
        setTempState({
          ...activeCampaignData
        });
      }
    };
    $[7] = activeCampaignData;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== activeCampaignData || $[10] !== opened) {
    t5 = [activeCampaignData, opened];
    $[9] = activeCampaignData;
    $[10] = opened;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== activeCampaignData || $[13] !== errors || $[14] !== isFetching || $[15] !== onSubmit || $[16] !== opened || $[17] !== t || $[18] !== tempState || $[19] !== user?.dashboardLocale) {
    t6 = <>{activeCampaignData ? <><WrapperIntegration icon={<ActiveCampaignIntegrationIcon />} title={t("dashboard.user_settings.integrations_page.active_campaign.name")} subTitle={t("dashboard.user_settings.integrations_page.active_campaign.subtitle-2")} onClick={handleOpenModal} isConnect={activeCampaignData.active} /><Modal title={t("dashboard.user_settings.integrations_page.active_campaign.title")} onClose={handleCloseModal} opened={opened} isFetching={isFetching} afterLeave={handleAfterLeaveModal}><><div className="mb-2.5 lg:mb-7"><span><TransLoco t={t} i18nKey="dashboard.user_settings.integrations_page.active_campaign.help" components={{
                  a: <a href={getHelpPageLinkActiveCampaign(user?.dashboardLocale)} target="_blank" rel="noreferrer" className="primary-link" />,
                  b: <b />
                }} /></span></div><div className="mb-3 flex flex-col gap-3.5"><Checkbox value={tempState.active} label={t("global.activate")} onChange={() => setTempState(_temp)} /><FormInput label={t("dashboard.user_settings.integrations_page.active_campaign.api_url_title")} required={true} value={tempState.apiUrl || ""} onChange={e_0 => {
                setTempState(prev_2 => ({
                  ...prev_2,
                  apiUrl: e_0.target.value
                }));
              }} error={errors.apiUrl} /><FormInput label={<Hint label={t("dashboard.user_settings.integrations_page.active_campaign.api_key_popover_title-2")}>{t("dashboard.user_settings.integrations_page.active_campaign.api_key_title")}</Hint>} required={true} value={tempState.token || ""} onChange={e_1 => setTempState(prev_3 => ({
                ...prev_3,
                token: e_1.target.value
              }))} error={errors.token} /></div><div className="mb-2.5 flex flex-col gap-2 lg:mb-7"><Hint label={t("dashboard.user_settings.integrations_page.active_campaign.triggers_popover_title-2")} className="mb-2.5">{t("dashboard.user_settings.integrations_page.active_campaign.triggers_title")}</Hint><div className="flex flex-col gap-4">{Object.entries(ActiveCampaignTriggerTitle).map(t7 => {
                  const [key, title] = t7;
                  const isSelected = tempState.triggers.includes(key as ActiveCampaignTriggerEnum);
                  const label = t(title);
                  return <div key={key}><Checkbox value={isSelected} label={<div className={`flex items-center gap-1.5 ${isSelected && "[&>svg]:fill-brand-primary [&>svg]:main-transition-colors"}`}>{label}</div>} onChange={() => isSelected ? setTempState(prev_4 => ({
                      ...prev_4,
                      triggers: prev_4.triggers.filter(method => method !== key)
                    })) : setTempState(prev_5 => ({
                      ...prev_5,
                      triggers: [...prev_5.triggers, key as ActiveCampaignTriggerEnum]
                    }))} /></div>;
                })}</div></div><div className="flex justify-center"><PrimaryButton onClick={onSubmit} isFetching={isFetching}>{t("global.save")}</PrimaryButton></div>{errors.common && <>{errors.common.map(_temp2)}</>}</></Modal></> : <WrapperIntegrationSkeleton />}</>;
    $[12] = activeCampaignData;
    $[13] = errors;
    $[14] = isFetching;
    $[15] = onSubmit;
    $[16] = opened;
    $[17] = t;
    $[18] = tempState;
    $[19] = user?.dashboardLocale;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
function _temp(prev_1) {
  return {
    ...prev_1,
    active: !prev_1.active
  };
}
function _temp2(error, index) {
  return <p className="text-danger text-sm" key={index}>{error}</p>;
}